/**
 * 홈페이지 서비스 문의 섹션 컴포넌트
 * 전화번호 캐러셀과 연락처 정보를 표시합니다.
 */

import styled from 'styled-components';
import {
  SERVICES,
  // FAX_INFO,
  // EMAIL_INFO,
  // MAIN_PHONE,
} from '../../constant/contactInfo';

/**
 * ServiceContactSection 컴포넌트
 * 서비스별 전화번호를 전체 리스트 형태로 표시하고, 팩스와 이메일 정보를 제공합니다.
 */
function ServiceContactSection() {
  return (
    <ServiceTel>
      <TelTitle>서비스문의</TelTitle>
      <TelDesc>전화주시면 친절히 성심 성의껏 답변해 드립니다.</TelDesc>

      {/* 전화번호 전체 리스트 */}
      <ServiceList>
        {SERVICES.map((service, index) => (
          <ServicePhoneItem key={index}>
            <PhoneLabel>{service.label}</PhoneLabel>
            <PhoneNumber>{service.phone}</PhoneNumber>
          </ServicePhoneItem>
        ))}
      </ServiceList>

      {/* <ContactDetails>
        <ContactRow>
          <ContactItem>법인 대표 번호 : {MAIN_PHONE}</ContactItem>
        </ContactRow>
        <ContactRow>
          <dt>팩스</dt>
          <dd>
            <ContactItem>- 돌봄 : {FAX_INFO.돌봄}</ContactItem>
            <ContactItem>- 사회적기업 : {FAX_INFO.사회적기업}</ContactItem>
          </dd>
        </ContactRow>
        <ContactRow>
          <dt>이메일</dt>
          <dd>
            <ContactItem>- 돌봄 : {EMAIL_INFO.돌봄}</ContactItem>
            <ContactItem>- 사회적기업 : {EMAIL_INFO.사회적기업}</ContactItem>
          </dd>
        </ContactRow>
      </ContactDetails> */}
    </ServiceTel>
  );
}

export default ServiceContactSection;

/* Styled Components */

/* 공통 박스 스타일 */
const ServiceBox = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  flex: 1;

  border: 1px solid #d7d7d7;
  font-family: 'Nanum Gothic Bold';
  box-sizing: border-box;
  padding: 20px 22px 12px;
  display: flex;
  flex-direction: column;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    border: none;
    border-top: 1px solid #f0f0f0;
    padding: 21px 0 25px 0;
  }
`;

const ServiceTel = styled(ServiceBox)`
  /* 모바일에서 배경색 추가 */
  @media (max-width: 1023px) {
    background-color: #fcf5f4;
  }
`;

/* 공통 타이틀 스타일 */
const BoxTitle = styled.h3`
  /* 데스크톱 기본 스타일 */
  font-size: 20px;
  font-weight: bold;
  color: #e5857c;
  font-family: 'Nanum Gothic Bold';
  margin: 0 0 8px 0;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    padding-left: 6%;
    font-size: 20px;
  }

  @media (max-width: 375px) {
    font-size: 18px;
  }

  @media (max-width: 320px) {
    font-size: 16px;
  }

  @media (min-width: 425px) and (max-width: 1023px) {
    font-size: 21px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 22px;
  }
`;

/* 공통 설명 스타일 */
const BoxDesc = styled.p`
  /* 데스크톱 기본 스타일 */
  font-size: 14px;
  color: #212121;
  font-family: 'koPubWorld DotumB';
  margin: 0 0 20px 0;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    padding-left: 6%;
    margin-top: 7px;
    font-size: 15px;
    margin: 7px 0 10px 0;
  }

  @media (max-width: 375px) {
    font-size: 13px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }

  @media (min-width: 425px) and (max-width: 1023px) {
    font-size: 17px;
  }
`;

const TelTitle = styled(BoxTitle)``;
const TelDesc = styled(BoxDesc)`
  margin-bottom: 5px;
`;

const ServiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 5px;

  @media (max-width: 1023px) {
    padding: 0 6%;
    gap: 12px;
  }
`;

const ServicePhoneItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-left: 3px solid #e5857c;
  transition: all 0.2s ease;

  &:hover {
    background-color: #fff0ee;
    border-left-color: #d16f68;
    transform: translateX(3px);
  }

  @media (max-width: 1023px) {
    padding: 10px 12px;
  }
`;

const PhoneLabel = styled.span`
  font-size: 14px;
  font-family: 'koPubWorld DotumB';
  color: #555555;
  font-weight: bold;
  min-width: 140px;
  flex-shrink: 0;

  @media (max-width: 1023px) {
    font-size: 13px;
    min-width: 120px;
  }
`;

const PhoneNumber = styled.span`
  /* 데스크톱 기본 스타일 */
  font-size: 18px;
  font-family: 'Nanum Gothic Bold';
  font-weight: bold;
  color: #ea4336;

  /* 모바일 스타일
  @media (max-width: 1023px) {
    font-size: 28px;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  @media (max-width: 425px) {
    font-size: 26px;
  }

  @media (max-width: 375px) {
    font-size: 24px;
  }

  @media (max-width: 320px) {
    font-size: 22px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 32px;
  } */
`;

const ContactDetails = styled.dl`
  /* 데스크톱 기본 스타일 */
  margin: 0;
  margin-top: 10px;
  padding-top: 10px;
  line-height: 1.5em;
  font-family: 'koPubWorld DotumB';

  border-top: 1px solid #e8e8e8;

  dt {
    float: left;
    margin-right: 5px;
  }

  dd {
    margin: 0;
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    padding-left: 6%;
    font-size: 13px;
    border-top: none;

    dt,
    dd {
      float: none;
      display: inline;
    }

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  @media (max-width: 375px) {
    font-size: 11px;
  }

  @media (max-width: 320px) {
    font-size: 13px;
  }

  @media (min-width: 425px) and (max-width: 1023px) {
    font-size: 14px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 17px;
  }
`;

const ContactRow = styled.div`
  display: flex;
  margin-bottom: 3px;
  font-size: 14px;
  line-height: 1.6;
  dt {
    flex-shrink: 0;
    width: 50px;
    float: none;
  }

  dd {
    margin: 0;
  }

  @media (max-width: 1023px) {
    font-size: 13px;
  }

  @media (max-width: 375px) {
    font-size: 12px;
  }
`;

const ContactItem = styled.div`
  line-height: 1.6;
  font-size: 14px;

  @media (max-width: 1023px) {
    font-size: 13px;
  }

  @media (max-width: 375px) {
    font-size: 12px;
  }
`;
